<template>
  <BaseWeb :logo-img="logoPhoto"
           :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum"
           class="many_recruit_btn" :download-path="downloadPath" :one-word="oneWord" :tow-word="towWord"></BaseWeb>
</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
  name: "pinDuoLe",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
    return{
      logoPhoto:require('../assets/pinDupLeImg/logo.png'),
      appPhotoArr:[
        {id:1,photo:require('../assets/pinDupLeImg/one.png')},
        {id:2,photo:require('../assets/pinDupLeImg/tow.png')},
        {id:3,photo:require('../assets/pinDupLeImg/three.png')},
        {id:4,photo:require('../assets/pinDupLeImg/four.png')},
      ],
      appName:'拼多乐',
      companyName:'厦门口袋零钱网络科技有限公司',
      icpNum:'闽ICP备20004855号-2',
      downloadPath:'http://apk.hotbuybuy.com/cmjz_oppo_100.apk',
      oneWord:'拼多乐是一款拼图APP，拥有乐趣与益智类的关卡，将帮助用户训练大脑，提升观察技能，运动技能，逻辑和注意力！',
      towWord:'',
    }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:rgb(26, 78, 203);
}
</style>



// WEBPACK FOOTER //
// src/components/pinDuoLe.vue